export default __webpack_public_path__ + "empty-pipe-icon.png";